(() => {
  'use strict';
  if (customElements.get('fd-collection-promo')) return;
  class FDCollectionPromo extends HTMLElement {
    connectedCallback() {
      if (this.fdReady) return;
      this.fdReady = true;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-fd-copy-code]')) this.copyCode();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const details = this.querySelector('details[open]');
        if (details) { details.open = false; details.querySelector('summary')?.focus(); }
      });
    }
    async copyCode() {
      const code = this.dataset.promoCode;
      const status = this.querySelector('[data-fd-copy-status]');
      const button = this.querySelector('[data-fd-copy-code]');
      if (!code || !status || !button || this.fdCopying) return;
      this.fdCopying = true;
      let success = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          try { await navigator.clipboard.writeText(code); success = true; } catch (_) { /* Try native selection fallback. */ }
        }
        if (!success) {
          const field = document.createElement('textarea');
          field.value = code;
          field.readOnly = true;
          field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
          document.body.appendChild(field);
          try { field.select(); success = document.execCommand('copy'); }
          finally { field.remove(); button.focus({preventScroll:true}); }
        }
      } catch (_) { success = false; }
      finally { this.fdCopying = false; }
      status.textContent = success ? status.dataset.copiedLabel : status.dataset.helpLabel;
      if (!success) {
        const text = this.querySelector('[data-fd-code-text]');
        const selection = window.getSelection();
        if (text && selection) {
          const range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges(); selection.addRange(range);
        }
      }
      clearTimeout(this.fdTimer);
      this.fdTimer = setTimeout(() => { status.textContent = ''; }, 3000);
    }
    disconnectedCallback() { clearTimeout(this.fdTimer); }
  }
  customElements.define('fd-collection-promo', FDCollectionPromo);
})();
